// extracted by mini-css-extract-plugin
module.exports = {"container":"Details-module__container--IgzzZ","noBottomBorder":"Details-module__noBottomBorder--15rGB","textEnd":"Details-module__textEnd--3l70b"};